<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{title}}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <router-link to="/login" v-on:click.native="logout()">
                  <span class="sidebar-mini">{{this.$lang.menu.logout_mini}}</span>
                  <span class="sidebar-normal">{{this.$lang.menu.logout}}</span>
                </router-link>
              </li>
              <!-- <li>
                <a href="#vue">
                  <span class="sidebar-mini">S</span>
                  <span class="sidebar-normal">Settings</span>
                </a>
              </li>-->
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";
import config from "@/config/config";

export default {
  components: {
    CollapseTransition
  },
  /*      props: {
    title: {
      type: String,
      default: ""
    },
    avatar: {
      type: String,
      default: ""
    } 
  },*/
  data() {
    return {
      isClosed: true,
      avatar: "/img/default-avatar.png",
      title: ""
    };
  },
  computed: {
    getAuth() {
      return this.$store.getters.getAuth;
    }
  },
  created() {
    if (this.getAuth.id === 1) {
      this.title = this.getAuth.user;
    }
  },
  methods: {
    logout() {
      this.$store.commit("Logout");
    },
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>

<style>
.collapsed {
  transition: opacity 1s;
}
</style>
